import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { TriggerList } from 'widgets/TriggerList/ui/TriggerList'
import { useTriggersPageContext } from 'pages/triggers/context'

export const AllTriggers = observer(() => {
  const { pageLayoutStore } = useTriggersPageContext()

  return (
    <FullPageWrapper>
      <TriggerList storeProps={{ type: 'all', pageLayoutStore }} />
    </FullPageWrapper>
  )
})
